import styles from './Home.module.css'
import { useEffect } from 'react'

import './home-animations.css'
import HomeSVG from '../../components/SVG/Home/Home'
import { animations, removeAnimation } from "../../scripts/animations"
import { scrambleAnimation}  from '../../scripts/home/script-home'

export default function Home({ visited }) {
    
    useEffect(() => {
        const scrambleElement = document.querySelector('#scramble');
        const startFontSize = parseFloat(window.getComputedStyle(scrambleElement).getPropertyValue('font-size'));
        
        if (!visited) {
            animations(1500, '.group-home');
            setTimeout(() => {
                scrambleAnimation(startFontSize);
            }, 2100);
        } else {
            removeAnimation('.group-home');
            scrambleAnimation(startFontSize)
        }
    }, [])


    return (
        <main className="main-vertical">
            <HomeSVG visited={visited}></HomeSVG>
            <section className='text-section section-vertical -mt-8'>
                <div className={styles.titlesContainer}>
                    <h1 className={`${styles.homeTitleExtraLarge} group-home toScale`}>Bonjour !</h1>
                    <h2 className={`${styles.homeTitleLarge} group-home toScale`}>Je suis Erika</h2>
                    <p className={`${styles.homeTitleSmall} group-home toScale`}>Et je suis</p>
                    <p className={`${styles.homeTitle} group-home toScale mx-auto`}>Web développeuse</p>
                </div>
                <div className={`${styles.homeAbout} group-home hide`} id="scrambleContainer">
                    <h2 className={styles.aboutTitle}>À propos de moi :</h2>
                    <p id="scramble" className={styles.scramble}>K</p>
                    <div className={styles.aboutParagraph}>
                        <p>Passionnée par l'informatique dès mon plus jeune âge, j'ai décidé d'en faire mon métier. 
                            En octobre 2023, j'ai obtenu le titre RNCP de Développeur Web et Web Mobile.</p>
                        <p>Aujourd'hui, je recherche une alternance en tant que Conceptrice développeuse d'applications afin de consolider mes acquis et
                            pouvoir continuer mes études à la 3W Academy pour 12 mois.</p>
                        <p>Avec ma créativité, ma curiosité insatiable et ma persévérance, je suis convaincue que je suis en mesure de répondre 
                        aux défis de votre entreprise et ainsi participer à ses succès futurs !</p>
                    </div>
                </div>
            </section>
        </main>
    )
}